import { render, staticRenderFns } from "./amendRule.vue?vue&type=template&id=37f03cb1&scoped=true&"
var script = {}
import style0 from "./amendRule.vue?vue&type=style&index=0&id=37f03cb1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f03cb1",
  null
  
)

export default component.exports